// Conventions every trend section shares. They all read the same two rounds
// against each other, so they have to agree on what counts as a real change,
// how a signed change is written, and what the small print says.

// Under this, a change is inside the normal round-to-round wobble.
export const MEANINGFUL_DELTA = 0.3;

// Signed change with an explicit +/− and two decimals. No change is written
// "+0.00" rather than a bare "0.00": every value in a column then carries a
// sign, so the digits stay in a straight line down the table.
export const formatDelta = (delta) => `${delta < 0 ? '−' : '+'}${Math.abs(delta).toFixed(2)}`;

// Whether a change is big enough to call.
//
// Tested against the delta rounded to the two decimals actually displayed.
// Comparing the raw float instead would dismiss a change reading "+0.30"
// whenever it is really 0.29999… — which is exactly what 5.31 − 5.01 is.
export const isMeaningfulChange = (delta) =>
    Math.round(Math.abs(delta) * 100) / 100 >= MEANINGFUL_DELTA;

// Built from the threshold itself so the number in the sentence can't drift
// away from the one being applied. Every trend section ends its small print
// with this; what differs is the sentence before it, saying who was compared.
export const MUTED_CHANGE_SENTENCE = `Changes smaller than ${MEANINGFUL_DELTA.toFixed(2)} are within the normal range and shown muted.`;

export const TREND_NOTE = `Only participants with an earlier 360 are compared. ${MUTED_CHANGE_SENTENCE}`;
